import React from 'react';
import { DateRangeDropdownV2, FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { QUERY_KEYS, taiKhoanSearchColumns } from '@/constants';
import { Label } from '@/components/ui/label';

interface Props {
  formMode: 'add' | 'edit' | 'view';
}

const BasicInfoTab = ({ formMode }: Props) => {
  return (
    <div className='space-y-4 p-4'>
      {/* Ngày h.toán từ/đến */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Ngày h.toán từ/đến</Label>
        <div className='w-[450px]'>
          <DateRangeDropdownV2
            fromDateName='ngay_tu'
            toDateName='ngay_den'
            toFieldClassName='w-48'
            fromFieldClassName='w-48'
          />
        </div>
      </div>

      {/* Được thanh toán để */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Được thanh toán để</Label>
        <div>
          <FormFieldV2 name='duoc_thanh_toan_de' type='date' disabled={formMode === 'view'} className='w-48' />
        </div>
      </div>

      {/* Ngày tất toán */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Ngày tất toán</Label>
        <div>
          <FormFieldV2 name='ngay_tat_toan' type='date' disabled={formMode === 'view'} className='w-48' />
        </div>
      </div>

      {/* Tài khoản nợ */}
      <div className='flex items-center gap-x-4'>
        <Label className='min-w-[150px] text-sm font-normal'>Tài khoản nợ</Label>
        <div className='flex-1'>
          <SearchField
            disabled={formMode === 'view'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={taiKhoanSearchColumns}
            columnDisplay='code'
            displayRelatedField='name'
            name='tai_khoan_no'
            dialogTitle='Danh mục tài khoản'
            className='w-fit'
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
